import { ChartTooltip } from "@app/components/Dashboard/ChartTooltip";
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ComposedChart,
  Area,
} from "recharts";
import { ResponsiveContainer } from "../../ResponsiveContainer";
import { getYAxisWidth } from "../../utils/chart-utils";
import { useNumber } from "../../hooks/useNumerFormatter";
import { useFormatDateInterval } from "../../hooks/useFormatDateInterval";
import { useChartContext } from "../ShortsworksChart/ChartProvider";

interface IChartData {
  data: Record<string, any>[];
}

export const ShortsworksLineChart = ({ data }: IChartData) => {
  const { interval, chartId } = useChartContext();
  const formatDate = useFormatDateInterval(interval);
  const number = useNumber();

  return (
    <div className="linechart">
      <ResponsiveContainer>
        {({ width, height }) => (
          <ComposedChart key={"ccc1"} width={width} height={height} data={data}>
            <Area
              dot={true}
              type={"monotone"}
              name={chartId}
              isAnimationActive={false}
              strokeWidth={2}
              dataKey="value"
              stroke={"#BC3BE9"}
              // Use for legend
              fill={`url(#color_1)`}
            />
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal={true}
              vertical={false}
              stroke={"#cecece"}
            />
            <YAxis
              className="fs_12"
              fontSize={12}
              width={getYAxisWidth(900)}
              axisLine={false}
              tickLine={false}
              allowDecimals={false}
              tickFormatter={number.short}
            />
            <XAxis
              className="fs_12"
              axisLine={false}
              fontSize={12}
              dataKey="day"
              // scale="utc"
              // domain={['dataMin', 'dataMax']}
              tickFormatter={(m: string) => formatDate(new Date(m))}
              tickLine={false}
            />
            {/* @ts-ignore */}
            <Tooltip content={<ChartTooltip />} />
            <defs>
              <linearGradient id={`color_1`} x1="0" y1="0" x2="0" y2="1">
                <stop
                  offset="0%"
                  stopColor={"#D893F2"}
                  stopOpacity={0.8}
                ></stop>
                <stop offset="100%" stopColor={"#FFF"} stopOpacity={0.1}></stop>
              </linearGradient>
            </defs>
          </ComposedChart>
        )}
      </ResponsiveContainer>
    </div>
  );
};
